interface Result {
  types: string[];
  address_components: AddressComponent[];
}

interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}
export const clientZipcodeAndCity = (results: Result[]) => {
  if (!Array.isArray(results)) return;

  const ZIP_CODE = 'postal_code';
  const CITY = 'locality';

  const zipCode = results.find((result) => result.types.includes(ZIP_CODE))?.address_components[0]?.long_name || '';
  const cityName = results.find((result) => result.types.includes(CITY))?.address_components[0]?.long_name || '';

  return `${zipCode} ${cityName}`;
};
